module.exports = __webpack_public_path__ + "static/media/addvideo_step2.1aa3dc30.png";